import { Injectable } from '@angular/core';
import { IBreadCrumb } from 'app/shared/shared.types';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BreadcrumbService {
    private breadcrumbsSource = new BehaviorSubject<IBreadCrumb[]>([]);
    breadcrumbs$ = this.breadcrumbsSource.asObservable();

    updateBreadcrumbs(breadcrumbs: IBreadCrumb[]) {
        this.breadcrumbsSource.next(breadcrumbs);
    }
}
